export default function BombBlastIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="10" fill="#4FA65A" />
      <rect x="6" y="6" width="14" height="14" rx="2" fill="#7F8898" />
      <rect x="44" y="44" width="14" height="14" rx="2" fill="#7F8898" />
      <rect x="44" y="6" width="14" height="14" rx="3" fill="#B8763A" stroke="#7A4A20" strokeWidth="2" />
      <path d="M8 32h48M32 28v28" stroke="#FF7A2E" strokeWidth="9" strokeLinecap="round" />
      <path d="M10 32h44M32 30v24" stroke="#FFE36B" strokeWidth="4" strokeLinecap="round" />
      <circle cx="28" cy="30" r="13" fill="#1B1F27" />
      <circle cx="23" cy="25" r="4" fill="#5A6070" />
      <path d="M36 20 Q40 12 46 13" stroke="#C8B48A" strokeWidth="3" fill="none" strokeLinecap="round" />
      <circle cx="47" cy="12" r="4" fill="#FFE36B" />
      <circle cx="47" cy="12" r="1.8" fill="#FFFFFF" />
    </svg>
  );
}
